
import vClickOutside from 'v-click-outside'

export default {
  directives: {
    clickOutside: vClickOutside.directive
  },
  props: {
    panelClass: {
      type: String,
      default: ''
    }
  },
  computed: {
    panelClasses () {
      const base = 'absolute top-full z-50 max-h-60 min-w-0 overflow-y-auto rounded-md border border-alto bg-alabaster shadow-md'
      const defaultLayout = 'inset-x-0 mt-1 w-full'
      return [base, this.panelClass || defaultLayout].join(' ')
    }
  },
  methods: {
    close () {
      this.$emit('close')
    }
  }
}
